module.exports = __webpack_public_path__ + "img/1.f200e88a.jpg";